<template>
  <b-autocomplete
    v-model="tempValue"
    :data="filterredOptions"
    :open-on-focus="true"
    placeholder="type to show options"
    icon="magnify"
    @select="option => $emit('select', option)">
    <template slot="empty">No results found</template>
  </b-autocomplete>
</template>


<script>
export default {
  props: {
    initialValue: String,
    options: Array,
  },
  data() {
    return {
      tempValue: this.initialValue || '',
    };
  },
  computed: {
    filterredOptions() {
      return this.options.filter(option => option
        .toString()
        .toLowerCase()
        .indexOf(this.tempValue.toLowerCase()) !== -1);
    },
  },
};
</script>
